import { render, staticRenderFns } from "./chengzai.vue?vue&type=template&id=504d308b&scoped=true"
import script from "./chengzai.vue?vue&type=script&lang=js"
export * from "./chengzai.vue?vue&type=script&lang=js"
import style0 from "./chengzai.vue?vue&type=style&index=0&id=504d308b&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "504d308b",
  null
  
)

export default component.exports